import { Option } from '../../../interface/form/template';
import { AccessTypes, VisibilityEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';

export const accessOptions: Option<AccessTypes>[] = [
  { label: 'Приватный', value: 'private' },
  { label: 'Публичный', value: 'public' },
  { label: 'Дефолтный', value: 'default' },
];

export const visibilityOptions: Option<VisibilityEnum>[] = [
  { label: 'Все', value: 'all' },
  { label: 'Супер админы', value: 'superAdmin' },
];
